<template>
  <div v-if="total > 0">
    <div
      class="tw-flex tw-flex-col tw-gap-2 tw-py-3 tw-px-1 tw-text-[#1F2229]"
    >
      <!-- Uploading -->
      <div
        v-if="uploading > 0"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i class="fas fa-spinner tw-animate-spin tw-text-[#F1583D]" />
        <span class="tw-font-bold">Uploading</span>
        <span>{{ uploading }} statements</span>
        <span
          class="tw-text-xs tw-text-blue-500 tw-cursor-pointer hover:tw-underline"
          @click="showDetails = !showDetails"
        >
          See details
        </span>
      </div>

      <!-- Completed -->
      <div
        v-if="completed > 0"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i class="fas fa-check tw-text-green-500" />
        <span class="tw-font-bold">Completed</span>
        <span>{{ completed }}/{{ total }}</span>
        <span
          class="tw-text-xs tw-text-blue-500 tw-cursor-pointer hover:tw-underline"
          @click="showDetails = !showDetails"
        >
          See details
        </span>
      </div>

      <!-- Failed -->
      <div
        v-if="failed > 0"
        class="tw-flex tw-items-center tw-gap-2"
      >
        <i class="fas fa-exclamation-triangle tw-text-[#F1583D]" />
        <span class="tw-font-bold">Failed</span>
        <span>{{ failed }}/{{ total }}</span>
        <span
          class="tw-text-xs tw-text-blue-500 tw-cursor-pointer hover:tw-underline"
          @click="showDetails = !showDetails"
        >
          See details
        </span>
      </div>





    </div>

    <StakeModal v-model="showDetails">
      <PortfolioUploadStatus />
    </StakeModal>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useCheckupStore } from '@frontend/ui/stores/checkupStore';

import StakeModal from '@stakeui/StakeModal.vue';
import PortfolioUploadStatus from './PortfolioUploadStatus.vue';

export default {
  name: 'PortfolioUploadOverview',
  components: {
    StakeModal,
    PortfolioUploadStatus,
  },
  props: {
    // prop: { type: String, required: true },
    // prop: String,
  },
  data() {
    return { showDetails: false };
  },
  computed: {
    ...mapStores(useCheckupStore),
    total() {
      return this.checkupStore.files.length;
    },
    completed() {
      return this.checkupStore.files.filter(file => {
        return ['uploadCompleted', 'uploadValidated'].includes(file.uploadStatus);
      }).length;
    },
    failed() {
      return this.checkupStore.files.filter(file => {
        return ['uploadFailed', 'uploadInvalid'].includes(file.uploadStatus);
      }).length;
    },
    uploading() {
      return this.total - this.completed - this.failed;
    },
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
